import React from "react";
import moment from "moment";
import HtmlToReactParser from "html-to-react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";

import { getBlog } from "../../model/blog";
import { commonErr } from "../common/errors";
import Header from "../components/header";
import Footer from "../components/footer";
import { MessagePage } from "../common/messagebox";
import { LoadingPage } from "../common/loading";
import { formatTitleInUrl } from "../common/common";

// import bg from "../../static/images/background/bg-blog-1.jpg";

export default class Article extends React.Component {
	constructor() {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			blog: null,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		const blogId = this.props.match.params.blogId;
		if (blogId) {
			getBlog(blogId).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					blog: resp.data.data,
				});
			});
		}
	}

	componentDidUpdate(props) {
		const blogId = this.props.match.params.blogId;
		const prevBlogId = props.match.params.blogId;

		if (blogId && prevBlogId && blogId !== prevBlogId) {
			window.scrollTo(0, 0);

			getBlog(blogId).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					blog: resp.data.data,
				});
			});
		}
	}

	render() {
		var content;
		if (this.state.err === commonErr.INNIT || this.state.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (this.state.blog && this.state.blog.blog) {
			const blog = this.state.blog.blog;
			const relatedBlog = this.state.blog.relateBlogs;

			var htmlToReactParser = new HtmlToReactParser.Parser();
			var blogContent = htmlToReactParser.parse(blog.content);

			content = (
				<div className="blog-detail">
					<div className="m-container">
						<div className="blog-detail-main">
							<img loading="lazy" className="main-img" src={blog.thumb ? blog.thumb : null} />
							<div className="blog-detail-content">
								<div className="main-content" style={{ margin: "auto" }}>
									<div className="group-tag">
										<span className="info info-bg">Trải nghiệm</span>
									</div>
									<h2 className="m-title mg-bottom-l">{blog.title}</h2>
									<div className="content">{blogContent}</div>
								</div>
							</div>
							<div className="related-post">
								<h5 className="title">Bài viết liên quan</h5>
								<Swiper
									modules={[Pagination, Navigation]}
									className="swiper-related-post"
									slidesPerView={1.2}
									spaceBetween={10}
									navigation={{
										nextEl: ".related-post-next",
										prevEl: ".related-post-prev",
									}}
									pagination={{
										el: ".pagi-cover",
										clickable: true,
										dynamicBullets: true,
									}}
									breakpoints={{
										992: {
											slidesPerView: 3,
											spaceBetween: 20,
										},
										768: {
											slidesPerView: 2,
											spaceBetween: 16,
										},
										481: {
											slidesPerView: 1.4,
										},
									}}>
									{relatedBlog.map((a) => (
										<SwiperSlide key={a.id}>
											<Link to={`/blog/${formatTitleInUrl(a.title)}/${a.id}`} className="swiper-slide item-post">
												<div className="fix-img">
													<img loading="lazy" src={a.thumb} />
												</div>
												<h5>{a.title}</h5>
												<p className="disc">{a.desc}</p>
											</Link>
										</SwiperSlide>
									))}
									<div className="swiper-pagination pagi-cover" />
								</Swiper>
								<div className="swiper-button-prev related-post-prev" />
								<div className="swiper-button-next related-post-next" />
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy nội dung."} />;
		}

		return (
			<div className="mioto-layout">
				<Header />
				<section className="body">{content}</section>
				<Footer />
			</div>
		);
	}
}
